export default "__VITE_ASSET__BzkEXzLG__"